import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency'
import { CurrencyCell } from '@root/entities/currency/ui/cells/currency-cell'
import { SwapDirectionCell } from '@root/entities/trade-type/ui'
import { useAppRoutes } from '@root/features/routing'

import type { Trade } from '@root/entities/trade'

type Props = {
  trade: Trade.Trade
}
export const WalletAlertsTableCurrencyColumn: React.FC<Props> = ({ trade }) => {
  const { navigateToTrading } = useAppRoutes()

  return (
    <Root>
      <SwapDirectionCell type={trade.type} size={22} />
      <CurrencyCellStyled
        onClick={() => {
          navigateToTrading(trade.pairAddress, trade.network)
        }}
        iconSize={22}
        tierRank={undefined}
        currency={
          trade.quoteCurrency ?? CurrencyModel.nullCurrency(trade.network)
        }
        pairAddress={trade.pairAddress}
      />
    </Root>
  )
}

const Root = styled.div<{ $clickable?: boolean }>`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  overflow: hidden;
  align-items: center;
  padding-inline-end: 4px;
  gap: 8px;
`

const CurrencyCellStyled = styled(CurrencyCell)`
  gap: 6px;
`
